import { TextColorType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLHeadingElement>["className"];
  color?: TextColorType;
  fontWeight?: 600 | 700;
  id?: HTMLAttributes<HTMLHeadingElement>["id"];
  lineHeight?: number;
  textAlign?: CSSProperties["textAlign"];
}>;

export default function Display({
  children,
  className,
  color,
  fontWeight,
  id,
  lineHeight,
  textAlign,
}: Props) {
  const styles: CSSProperties = {
    color: `var(--color-text-${color || "primary"})`,
    fontSize: "var(--font-size-display)",
    fontWeight: fontWeight || 700,
    lineHeight: lineHeight || "var(--line-height-heading)",
    textAlign: textAlign || "start",
  };

  return (
    <h1 className={className} id={id} style={styles}>
      {children}
    </h1>
  );
}
